// libs/utils/useMetadataParser.ts
import { TypeProgram_metaWithoutUnresolvableLinksResponse } from '@2u-landing-pages/types';
import { useMemo } from 'react';
import { formatDate } from './formatting';

export const useMetadataParser = (
  metadata: TypeProgram_metaWithoutUnresolvableLinksResponse,
) => {
  // This is a utility function to parse metadata from a template string
  const parseMetadata = useMemo(() => {
    return (template: string): string => {
      const regex = /\{\{meta\.([\w\.]+)\}\}/g;

      if (!metadata) return template;

      return template.replace(regex, (_, path) => {
        try {
          const parts = path.split('.');
          let value: any = metadata.fields;

          for (const part of parts) {
            if (value === undefined || value === null) {
              throw new Error(`Invalid path: ${path}`);
            }
            if (part.includes('primary_')) {
              value = value[part].value;
            } else {
              value = value[part];
            }
          }

          // Format start_date from ISO format to readable format
          if (path.endsWith('start_date') && value) {
            return formatDate(value);
          }

          return value?.toString() || '';

        } catch (error) {
          console.error(`Error parsing metadata path "${path}":`, error);
          return '';
        }
      });
    };
  }, [metadata]);

  // Get all fields from metadata directly
  const fields = useMemo(() => {
    const {
      name,
      school_name,
      program_name,
      topic,
      logo,
      start_date,
      tuition_cost,
      latitude,
      longitude,
      ranking,
      duration,
      weekly_commitment,
      alumni_network,
      school,
    } = metadata?.fields || {};

    return {
      name,
      school_name,
      program_name,
      topic,
      logo,
      start_date,
      tuition_cost,
      latitude,
      longitude,
      ranking,
      duration,
      weekly_commitment,
      alumni_network,
      school,
    };
  }, [metadata]);

  return {
    parseMetadata,
    fields
  };
};
